import React,{useState} from 'react'
import {Button,Modal,Form} from 'react-bootstrap'
import {IconContext} from 'react-icons'
import {FaWindowClose,FaTimes} from 'react-icons/fa'
import TnC from './tnc'
import Privacy from './privacy'

function Index() {

    const handleClose = () => setModalContent('');
    const handleShow = (content) => setModalContent(content);
    const [ModalContent, setModalContent] = useState('')

    return (
        <>
            <div className="px-2 mt-2 d-flex" style={{userSelect:'none'}}>
                <Form.Check
                    type="checkbox"
                    id="privacyPolicy"
                    required
                    />
                    <p> I agree to the
                        <span className="cursor-pointer text-primary" onClick={()=>{handleShow('TNC');}}> terms and conditions</span> and
                        <span className="cursor-pointer text-primary" onClick={()=>{handleShow('PRIVACY');}}> privacy policy</span> of the website
                    </p>
            </div>
            <Modal show={(ModalContent === 'PRIVACY' || ModalContent === 'TNC')} onHide={handleClose} size="xl">
                <Modal.Body className="px-4 pb-0">
                    <div className="px-4 cursor-pointer" style={{position:'absolute',top:'32px',right:'25px'}} onClick={handleClose}>
                        <IconContext.Provider value={{color:'#6c757d'}}>
                            <FaWindowClose/>
                        </IconContext.Provider>
                    </div>
                </Modal.Body>
                {ModalContent === 'PRIVACY' &&  <>
                    <h4 className="mb-3 px-4 py-3"><strong>Privacy Policy</strong></h4>
                    <div className="modal-container px-3 px-md-4 mx-4">
                        <Privacy/>
                    </div>
                    </>
                }
                {ModalContent === 'TNC' && <>
                    <h4 className="mb-3 px-4 py-3"><strong>Terms and Conditions</strong></h4>
                    <div className="modal-container px-3 px-md-4 mx-4">
                        <TnC handleShow={handleShow}/>
                    </div>
                    </>
                }
                <div className="d-flex p-3 justify-content-between">
                    <Button variant='white' className="border border-black" style={{marginLeft:"auto"}} onClick={handleClose}>
                        <div className="d-flex align-items-center">
                            <IconContext.Provider value={{color:'#6c757d'}}>
                                <FaTimes/> &nbsp;
                            </IconContext.Provider>
                            <p className="text-secondary mb-0">Close</p>
                        </div>
                    </Button>
                </div>
            </Modal>
        </>
    )
}

export default Index
